var map = {
	"./ajuda/whatsapp.svg": 69367,
	"./ajuda/youtube.svg": 86400,
	"./background/bg.png": 50708,
	"./clube/banner-clube-conecta.jpg": 65446,
	"./compartilhar/dominio.svg": 33078,
	"./compartilhar/icone_guia.svg": 41405,
	"./conteudos/1.png": 53208,
	"./header/check.svg": 21455,
	"./header/logotipo.svg": 63768,
	"./home/IconeAtualizacoesSistema.svg": 72540,
	"./home/IconeClubeConectado.svg": 31897,
	"./home/IconeGuia.svg": 97329,
	"./home/IconeGuiaMobile.svg": 93424,
	"./home/IconeGuiaMobile_dark.svg": 45551,
	"./home/IconeGuia_dark.svg": 30746,
	"./home/catalog.svg": 5644,
	"./home/clubeConectado_dark.svg": 17364,
	"./home/clubeConectado_light.svg": 30114,
	"./home/image_produto.png": 18878,
	"./home/novidades/1.jpg": 69733,
	"./home/novidades/1dark.jpg": 63435,
	"./home/novidades/1new.jpg": 3485,
	"./home/novidades/1newdark.jpg": 31981,
	"./home/novidades/2.jpg": 85414,
	"./home/novidades/2dark.jpg": 70901,
	"./home/novidades/3.jpg": 93480,
	"./home/novidades/3dark.jpg": 60114,
	"./home/novidades/banner-cafe.png": 30360,
	"./home/novidades/banner-mentoria.png": 65742,
	"./home/novidades/cafe.svg": 36390,
	"./home/novidades/cafedark.svg": 65132,
	"./home/novidades/mentoria.svg": 81256,
	"./home/novidades/mentoriadark.svg": 45413,
	"./home/pedido.svg": 86862,
	"./home/produtos.svg": 97140,
	"./home/relatorios.svg": 40459,
	"./home/sacola.svg": 20247,
	"./icons/DashPedidos.svg": 11046,
	"./icons/DashProdutos.svg": 12184,
	"./icons/DashSacolas.svg": 11019,
	"./icons/DashTicket.svg": 30841,
	"./icons/DashVisitas.svg": 71777,
	"./icons/DashVisitasCatalogos.svg": 237,
	"./icons/angle-down.svg": 98206,
	"./icons/arrow-left.svg": 47781,
	"./icons/arrow-right.svg": 82745,
	"./icons/arrow-up.svg": 43778,
	"./icons/arrowLeft.svg": 25087,
	"./icons/blip.svg": 85272,
	"./icons/bloqueado.svg": 35530,
	"./icons/calender.svg": 22602,
	"./icons/copiar.svg": 3927,
	"./icons/copy.svg": 76218,
	"./icons/descricao-ia.svg": 3786,
	"./icons/downDash.svg": 69393,
	"./icons/favorite.svg": 45870,
	"./icons/filter.svg": 51575,
	"./icons/foto-usuario.svg": 30008,
	"./icons/galery.svg": 33457,
	"./icons/info.svg": 54251,
	"./icons/liberado.svg": 12724,
	"./icons/link-h.svg": 73375,
	"./icons/loading.svg": 13458,
	"./icons/lock.svg": 39345,
	"./icons/macro.svg": 6833,
	"./icons/mail.svg": 23,
	"./icons/olho-de-tandera.svg": 74410,
	"./icons/options.svg": 88066,
	"./icons/options2.svg": 37248,
	"./icons/play.svg": 65591,
	"./icons/plus.svg": 39445,
	"./icons/recursos-ia.svg": 79751,
	"./icons/restaurar.svg": 75510,
	"./icons/rounded.svg": 36881,
	"./icons/search.svg": 23369,
	"./icons/sliders-v.svg": 70265,
	"./icons/sun.svg": 25914,
	"./icons/tag-diamond.svg": 97401,
	"./icons/telegram-alt.svg": 84274,
	"./icons/trash.svg": 90252,
	"./icons/upDash.svg": 82530,
	"./icons/wechat.svg": 72729,
	"./icons/whatsapp.svg": 31667,
	"./login/background.png": 76500,
	"./login/bg_mobile.png": 65908,
	"./login/fundo-login.jpg": 90560,
	"./menuLateral/Logo.svg": 15698,
	"./menuLateral/config.svg": 55768,
	"./menuLateral/dash.svg": 27573,
	"./menuLateral/painel.svg": 63082,
	"./menuLateral/share.svg": 29405,
	"./menuLateral/user.svg": 76592,
	"./modais/cobranca.svg": 29711,
	"./modais/cobrancaPlaceholder.svg": 4846,
	"./modais/criarProduto.svg": 16938,
	"./modais/criarProdutoPlaceholder.svg": 67289,
	"./modais/opcoesDeFrete.svg": 20674,
	"./modais/opcoesDeFretePlaceholder.svg": 37303,
	"./novidades/banner-2.jpg": 89142,
	"./novidades/banner.png": 44245,
	"./novidades/banner.svg": 60641,
	"./novidades/bannerMobile-2.jpg": 33767,
	"./novidades/bannerMobile.jpg": 37104,
	"./parceiros/bling.svg": 37837,
	"./parceiros/macro.svg": 4577,
	"./parceiros/redantex.svg": 87559,
	"./parceiros/tiny.svg": 16691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12339;